






















import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';
import {
  EmployeeTimeOffBookingBalance,
  IEmployeeTimeOffBookingBalance,
  ITimeOffRequest,
  TimeOffTypeFieldError
} from '@/models';
import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
import { getPropertyFromItem } from '@/utils/helpers';
import { isEqual } from 'lodash';

export default mixins(auth).extend({
  name: 'EmployeeTimeOffBalanceTypePicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, Object],

    label: {
      type: String,
      default: 'Type'
    },

    externalErrorMessage: {
      type: [Array, Object] as PropType<string[] | TimeOffTypeFieldError>,
      default: () => []
    },

    year: {
      type: Number,
      required: false
    },

    dialogBookingType: Number,

    timeOff: Object as PropType<ITimeOffRequest>,

    isEdit: Boolean
  },

  data() {
    return {
      lazyValue: this.value,
      search: '',
      errorMessage: '',
      timeOffLoading: false,

      localEmployeeTimeOffBalanceList: []
    };
  },

  computed: {
    ...mapGetters({
      employeeTimeOffBalance: 'employeeTimeOff/getEmployeeTimeOffBalances'
    }),

    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];

      if (!(this.externalErrorMessage instanceof TimeOffTypeFieldError)) {
        errorList = this.externalErrorMessage;
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true
    },

    year: {
      handler(year) {
        if (year) {
          this.genEmployeeTimeOffBalanceTypes(
            this.getItemValue(this.timeOff.employee),
            year
          );
        } else {
          this.resetPicker();
        }
      }
    },

    'timeOff.employee': {
      handler(val, oldVal) {
        if (isEqual(val, oldVal)) return;

        if (val && this.year) {
          const id = typeof val == 'object' ? val.id : val;
          this.genEmployeeTimeOffBalanceTypes(id, this.year);
        } else {
          this.resetPicker();
        }
      },
      immediate: true,
      deep: false
    }
  },

  methods: {
    ...mapActions({
      fetchEmployeeTimeOffBalance: 'employeeTimeOff/fetchEmployeeTimeOffBalance'
    }),

    async genEmployeeTimeOffBalanceTypes(employee: number, year: number) {
      this.timeOffLoading = true;

      this.fetchEmployeeTimeOffBalance({
        employee: employee,
        year: year
      })
        .then(data => {
          this.localEmployeeTimeOffBalanceList = this.employeeTimeOffBalance;
          if (this.isEdit) {
            const currentTimeOffBalance = this.localEmployeeTimeOffBalanceList.find(
              (data: IEmployeeTimeOffBookingBalance) =>
                this.getItemValue(data.employee_entitlement?.timeoff) ==
                this.getItemValue(this.timeOff.type)
            );
            if (currentTimeOffBalance) {
              this.internalValue = currentTimeOffBalance;
            }
          } else {
            //TODO MG-2022-12-01 look into why @change doesn't get called when internal value is updatedhere
            if (data[0]) {
              this.internalValue = data[0];
              this.$emit('change');
            }
          }
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.timeOffLoading = false));
    },

    getItemValue(item: any) {
      return getPropertyFromItem(item, 'id', item);
    },

    resetPicker() {
      this.localEmployeeTimeOffBalanceList = [];
      this.internalValue = null;
    }
  }
});
